import { lazy } from 'react'
import { BrowserRouter as Router, Routes, Route } from "react-router";
import './App.css'
import './index.css'
import VerticalLayout from './layout/VerticalSidebar';
import Products from './pages/products';
import Vendors from './pages/vendors';
import Categories from './pages/categories';
import Images from './pages/images';
import Login from './pages/login'
import Logout from './pages/login/Logout';
import SmsSendPage from './pages/sms';

const OrderDetails = lazy(() => import("./pages/orderDetails"));
const PendingOrders = lazy(() => import("./pages/pendingOrders"));
const ChatFlows = lazy(() => import("./pages/chatflows"));
const ChatFlowEdit = lazy(() => import("./pages/chatflows/edit"));
const ChatBrandingPage = lazy(() => import("./pages/chatBranding"));
const Organizations = lazy(() => import("./pages/organizations"));
const OrganizationDetail = lazy(() => import("./pages/organizations/detail"));
const EmailTemplatesPage = lazy(() => import("./pages/emailTemplates"));
const UserReport = lazy(() => import("./pages/reports/UserReport"));
const TwilioReport = lazy(() => import("./pages/reports/TwilioReport"));
const CsmPage = lazy(() => import("./pages/csm"));
const EvabotDataPage = lazy(() => import("./pages/evabotData"));
function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/logout" element={<Logout />} />
          <Route
            path="/"
            element={<VerticalLayout />}
          >
            <Route index element={<PendingOrders />} />
            <Route path="orders" element={<OrderDetails />} />
            <Route path="products" element={<Products />} />
            <Route path="vendors" element={<Vendors />} />
            <Route path="categories" element={<Categories />} />
            <Route path="images" element={<Images />} />
            <Route path="chatflows" element={<ChatFlows />} />
            <Route path="chatflows/:id/edit" element={<ChatFlowEdit />} />
            <Route path="chatbranding" element={<ChatBrandingPage />} />
            <Route path="organizations" element={<Organizations />} />
            <Route path="organizations/:id" element={<OrganizationDetail />} />
            <Route path="sms" element={<SmsSendPage />} />
            <Route path="email-templates" element={<EmailTemplatesPage />} />
            <Route path="reports/users" element={<UserReport />} />
            <Route path="reports/twilio" element={<TwilioReport />} />
            <Route path="csm" element={<CsmPage />} />
            <Route path="evabot-data" element={<EvabotDataPage />} />
          </Route>
        </Routes>
      </Router>
    </>
  )
}

export default App
